import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Stack, Tab } from "@mui/material";
import { useState } from "react";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { api } from "../../../api/operationsApi";
import LoadingFailedAlert from "../../common/LoadingFailedAlert";
import CreateInvestorPortalUserTab from "./CreateInvestorPortalUserTab";
import ResetInvestorPortalPasswordTab from "./ResetInvestorPortalPasswordTab";

type TabValue = "CreateInvestorPortalUser" | "ResetInvestorPortalPassword";

const UserManagementContent = () => {
  const [selectedTab, setSelectedTab] = useState<TabValue>("CreateInvestorPortalUser");
  const [organizations, fetchOrganizationsError] = useFetch(api.clientProvisioning.getExistingOrganizations);

  if (fetchOrganizationsError) {
    return <LoadingFailedAlert apiError={fetchOrganizationsError} />;
  }

  if (organizations === undefined) {
    return <InlineLoader />;
  }

  return (
    <Stack sx={{ alignItems: "flex-start", width: "100%", maxWidth: "64rem" }}>
      <TabContext value={selectedTab}>
        <TabList onChange={(_, value: TabValue) => setSelectedTab(value)}>
          <Tab label="Create Investor Portal User" value="CreateInvestorPortalUser" />
          <Tab label="Reset Investor Portal Password" value="ResetInvestorPortalPassword" />
        </TabList>

        <TabPanel value="CreateInvestorPortalUser" sx={{ px: 0 }}>
          <CreateInvestorPortalUserTab organizations={organizations} />
        </TabPanel>

        <TabPanel value="ResetInvestorPortalPassword" sx={{ px: 0 }}>
          <ResetInvestorPortalPasswordTab />
        </TabPanel>
      </TabContext>
    </Stack>
  );
};

export default UserManagementContent;
